
define('text!templates/modules/calendar/animated-session/exercise/lists/exercise-list-placeholder.html',[],function () { return '<div class="add-exercise drag-filter tc-col-3 tc-col-sm-6 tc-col-xs-12">\n    <div class="exercise-placeholder">\n        <span class="icon sl-icon-plus"></span> {{#t}}calendar:Click or drag & drop to add an exercise{{/t}}\n    </div>\n</div>\n';});

